import http from 'hub-http/clients/apiClient';
const API_BASE = '/cv/inbox/settings/v1/user-settings';
export default class MessageSettingsAPI {
  static getMessageSettings() {
    return http.get(API_BASE);
  }
  static updateMessageSettings(messageSettings) {
    return http.put(API_BASE, {
      data: messageSettings
    });
  }
}